<template>
    <div v-if="!emptyItem" class="row">
        <!-- item name -->
        <div class="col-7 q-pr-md text-left">
            {{ item.services.name }}
        </div>
        <!-- item quantity -->
        <div class="col-2 text-right q-pr-md">{{ item.quantity }}</div>
        <!-- item total -->
        <div class="col-3 text-uppercase text-right">
            {{ JSON.parse(item.item_total)[currency.key] }} {{ currency.key }}
        </div>
    </div>
</template>

<script>
import translate from '@/local-shared/mixins/translate'
import store from '@/store'
import _ from 'lodash'

export default {
    name: 'ServicesInInvoiceComponent',

    mixins: [translate],

    props: {
        item: {
            type: Object,
            default: () => {},
        },

        currency: {
            type: Object,
            default: () => {},
        },
    },

    computed: {
        locale() {
            return store.getters['locale/currentLocale']
        },

        emptyItem() {
            return _.isEmpty(this.item)
        },
    },
}
</script>
